// extracted by mini-css-extract-plugin
export default {"logo":"InfoPage_logo__pTEsH","content":"InfoPage_content__TqzO7"};